module.exports = __webpack_public_path__ + "3ae768e7779db88744900f13160995d4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/mt.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/mt.svg
// module chunks = 0